<div class="main">
    <div class="frm" dir="rtl">

        <h2 style="text-align: center;">{{had}}</h2>

        <form #f="ngForm" (ngSubmit)="submit()">
            <div class="row">
                <div class="btnSave">
                    <button class="btn btn-primary" [disabled]="f.invalid || isRequesting">Save</button>
                </div>
            </div>

            <div class="row frm2" style="background-color:#f4f4f4">
                <div class="row">
                    <div class="col-lg-4 pull-right">
                        <div class="form-group">
                            <label for="cityY" style="font-weight:bold">City Yidish</label>
                            <input required id="cityY" name="cityY" class="form-control" [(ngModel)]="city.cityY" />
                        </div>
                        <div class="form-group">
                            <label for="stateY" style="font-weight:bold">State Yidish</label>
                            <select required id="stateY" name="stateY" class="form-control" [(ngModel)]="city.stateId">
                                <option *ngFor="let s of states" [value]="s.id">{{s.stateY}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="col-lg-4 pull-right">
                        <div class="form-group" dir="ltr">
                            <label for="cityE" style="font-weight:bold">city English</label>
                            <input id="cityE" name="cityE" class="form-control" [(ngModel)]="city.cityE" />
                        </div>
                    </div>

                    <div class="col-lg-4 pull-right">
                        <div class="form-group">
                            <label for="cityMN" style="font-weight:bold">City Keywords</label>
                            <textarea id="cityMN" name="cityMN" [(ngModel)]="city.cityMN" cols="55" rows="5" class="form-control"></textarea>
                        </div>
                    </div>


                </div>
                <div class="row">
                    <div class="col-lg-4 pull-right">
                        <div *ngIf="errors" class="alert alert-danger" role="alert" dir="ltr">
                            <strong>Oops!</strong> {{errors}}
                        </div>
                    </div>
                </div>
            </div>

        </form>
    </div>
</div>